export default __webpack_public_path__ + "static/media/enabled-mail.27c52b45.svg";